import { Map, OrderedMap, fromJS } from 'immutable';

// Constants
import WorkspaceRecentUpdatesConstants from '../constants/WorkspaceRecentUpdates.constants';

const initialState = Map({
  [WorkspaceRecentUpdatesConstants.State.WORKSPACES_RECENT_UPDATES_BY_ID]: OrderedMap(),
});

export const WorkspaceRecentUpdatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case WorkspaceRecentUpdatesConstants.Actions.FETCH_RECENT_UPDATES_SUCCESS:
      return state.updateIn(
        [WorkspaceRecentUpdatesConstants.State.WORKSPACES_RECENT_UPDATES_BY_ID],
        (existing = OrderedMap()) =>
          existing.merge(
            OrderedMap(
              Object.values(action.payload.workspaceUpdate).map(item => [item.id, Map(fromJS(item.attributes))])
            )
          )
      );
    default:
      return state;
  }
};
